export default {
  status: {
    completed: '完了',
    pending: '保留',
    rejected: {
      action: '受注不可',
      state: '注文が拒否されました',
    },
    doing: '処理中',
    revoked: {
      state: '撤回済み',
      action: '撤回',
    },
    unpaid: '未払い',
    paid: '支払済み',
    fail: '支払い失敗',
  },
  list: {
    revoked: '撤回済み',
  },
  '3dmodel': {
    title: '3Dモデル処理中 (ベータ)',
    handle: '3Dモデル処理中',
    dialog: {
      modelManage: 'モデル作業指示書管理',
      serviceExplain: 'サービス説明',
      submit: 'モデル処理依頼を行いますか？',
      confirm: '確定',
      resubmit: '再度アップロード',
      success:
        'ご依頼は正常に送信されました。納品時間は1営業日以内にご連絡いたします。「マイアセット - 3Dモデル工単」で詳細な進捗状況をご確認ください。ご不明な点がございましたら、support@mindworks-creative.comまでご連絡ください。',
    },
    tips: {
      upload:
        '*モデルをアップロードしてください。弊社チームはプラットフォームの仕様と要件に基づき、互換性を確保し最適なパフォーマンスを引き出します。モデル提出後、1営業日以内に見積もりの回答をいたします。詳細はクリエイティブアセット-3Dモデル作業依頼でご確認いただけます。',
      credits:
        'モデル処理には{count}ポイント消費します（残り{balance}ポイント）',
      money: 'モデル処理には{count}が消費されます（残り{balance}）',
      videoSubmit:
        'モデル処理には{count}ポイント消費します（残り{balance}ポイント）。続行しますか？モデル提出後、1営業日以内に見積もりの回答をいたします。詳細はマイアセット-3Dモデル作業依頼でご確認いただけます。',
      moneySubmit:
        'モデル処理には$ {count}が消費されます（残高は$ {balance}です）。提出してもよろしいですか？モデルを提出してから1営業日以内に、予定される納期を回答いたします。マイアセット - 3Dモデル作業指示書で確認できます。',
      moneyTooltip: '作業指示書が提出されると、残高より料金が差し引かれます。',
      remark: '備考を入力してください',
      revoke: 'この3Dモデルの依頼をキャンセルしてもよろしいですか？',
    },
    uploader: {
      require:
        'ZIP形式のファイルをドラッグ＆ドロップまたはアップロードしてください。ZIPパッケージ内には、以下のファイル形式のみを含めることができます: モデルファイル: .fbx, .ma, .mb, .max, .glb, .gltf（.binとセットで必須）。 テクスチャファイル: .png, .jpg。',
      format: 'フォーマット',
      require1: '三角面数<10000、頂点数<8000、Mesh = 1',
      require2: 'テクスチャ数>=1',
      nosupportFormat: 'サポートされていないファイル形式',
      missModelFile: 'モデルファイルがありません',
      warning: {
        triangles: '三角面数 < 10000',
        vertex: '頂点数 < 8000',
        mesh: 'Mesh = 1',
        contentError: 'ファイルの内容が誤っています',
        picCountError: 'ファイル内容エラー。テクスチャが1つ以上必要です。',
      },
    },
    service: 'モデル処理サービス（ベータ）',
    tip: '通常のスキンエディタ内でモデルを使用可能にするため、プラットフォーム仕様と要件に基づいて、3Dモデル処理サービスを利用できます。',
  },
  name: '作業依頼',
  table: {
    column: {
      remark: '備考',
      status: 'ステータス',
      relativeProject: '関連プロジェクト',
      estimatedDeliverTime2: '予定納期',
      deliverTime: '実際の納期',
      categoryName: 'スロット名',
      createdTime: '作成日時',
      usageType: '支払方法',
      balance: '残高',
      videoCredits: 'ポイント',
      deduction: '引き落とし回数',
      count: '{count} ポイント',
    },
  },
  filter: {
    modelName: 'モデル名',
    orderId: '作業依頼ID',
    statusOptions: 'ステータス選択',
    '3dmodel': '3Dモデル',
  },
}
